import React from 'react';
import styled from 'styled-components';
import { HalfBanner } from '../components/Banners';
import { Title, Content } from '../components/Elements';
import Link from 'gatsby-link';
import MetaTags from '../components/MetaTags';
import { media } from '../components/helpers';

const FormWrap = styled.div`
	padding: 70px 30px 40px;
	background: #000;
	${media.medium`padding: 170px 30px 40px;`};

	form {
		overflow: hidden;
		label {
			color: #fff;
			display: none;
		}
		textarea {
			width: 100%;
			max-width: 100%;
			color: #fff;
			background: transparent;
			font-size: 20px;
			border: none;
			padding: 10px 0px 10px 10px;
			min-height: 250px;
			font-family: 'Lato', sans-serif;
			${media.medium`font-size: 30px; min-height: 300px;`};

			&:focus,
			&:active {
				outline: none;
				border: none;
			}
		}
		input {
			display: block;
			width: 100%;
			color: #fff;
			background: transparent;
			margin-bottom: 30px;
			padding: 10px 5px;
			font-size: 25px;
			border: none;
			font-family: 'Lato', sans-serif;
			${media.medium`font-size: 35px;`};
			/* border-bottom: 1px solid #fff; */

			&:focus,
			&:active {
				outline: none;
				border: none;
			}
		}

		.submit-button {
			font-size: 21px;
			text-transform: uppercase;
			letter-spacing: 2px;
			border: 1px solid #fff;
		}
	}

	.title-wrap {
		margin-bottom: 40px;
		h2 {
			color: #fff;
			text-align: center;
			font-size: 25px;
			font-weight: 300;
			${media.medium`font-size: 35px;`};
		}
	}
`;

const StyledContact = styled.div`
	.services-wrap {
		padding-bottom: 100px;
	}
`;

export default ({ data }) => (
	<StyledContact>
		<MetaTags title="Contact | Wavey Media Group" />
		<FormWrap>
			<Content>
				<div className="title-wrap">
					<h2>
						Please fill out the form below, and we will get back to you as soon
						as possible.
					</h2>
				</div>
				<form
					autoComplete="off"
					name="contact"
					method="post"
					action="/success"
					data-netlify="true"
					data-netlify-honeypot="bot-field"
				>
					<input type="hidden" name="form-name" value="contact" />
					<input name="bot-field" />
					<label htmlFor="name">Name</label>
					<input
						autoComplete="off"
						type="text"
						required
						placeholder="Name"
						name="name"
					/>
					<label htmlFor="email">Email</label>
					<input
						autoComplete="off"
						type="email"
						placeholder="Email"
						required
						name="email"
					/>
					<label htmlFor="email">Inquiry</label>
					<textarea
						autoComplete="off"
						placeholder="Inquiry"
						required
						name="inquiry"
					/>
					<div data-netlify-recaptcha />
					<input type="submit" className="submit-button" />
				</form>
			</Content>
		</FormWrap>
	</StyledContact>
);

export const query = graphql`
	query ContactData {
		topBanner: imageSharp(id: { regex: "/nyc.jpeg/" }) {
			sizes(quality: 100, maxWidth: 2300) {
				...GatsbyImageSharpSizes
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/contact.js